<template>
  <div class="one_step">
    <div class="step_shell for_pb" v-on:click="firstTimeDisplayed = false">
      <h2 class="details_header">{{header}}</h2>
      <h3 class="details_subheader">
        In order to process your application, we'll need to run a credit check on you and any other partners,
        directors or shareholders. Please confirm all details below.
      </h3>
      <div class="field_wrap textfield_wrap">
        <span class="field_label">First name</span>
        <v-text-field
          data-test-id="step-4-firstname"
          outlined
          v-model="Applicant_First_Name"
          color="#0200b9"
          :rules="name_rules"
          class="text_field"
          maxlength="30"
        />
      </div>

      <div class="field_wrap textfield_wrap">
        <span class="field_label">Last name</span>
        <v-text-field
          data-test-id="step-4-lastname"
          outlined
          v-model="Applicant_Last_Name"
          color="#0200b9"
          :rules="name_rules"
          class="text_field"
          maxlength="30"
        />
      </div>
      <div class="field_wrap textfield_wrap dob_field_wrap">
        <span class="field_label">Date of Birth</span>
        <input v-if="isIE11" data-test-id="step-4-dob" v-model="Applicant_Date_of_Birth" class="text_field" placeholder="dd/mm/yyyy"
          @change="debouncedCheckDob(1)"
          @blur="debouncedCheckDob(1)"
          @keyup="debouncedCheckDob(1)" />
        <input v-else
          data-test-id="step-4-dob"
          class="text_field"
          :class='{invalid: !applicant_1_dob_valid && applicant_1_dob_error}'
          :value="Applicant_Date_of_Birth"
          v-imask="dateMask"
          @accept="onAccept"
          @complete="onComplete"
          @change="debouncedCheckDob(1)"
          @blur="debouncedCheckDob(1)"
          @keyup="debouncedCheckDob(1)"
          @focus="focusInput1"
        />
        <span v-if="applicant_1_dob_error" class="error_text">{{applicant_1_dob_error}}</span>
      </div>

      <div class="field_wrap textfield_wrap address_lookup_wrap">
        <span class="field_label">Residential address</span>
        <v-text-field
          data-test-id="step-4-address"
          outlined
          v-model="Applicant_Address_Text"
          color="#0200b9"
          :rules="name_rules"
          placeholder="Start typing..."
          class="text_field"
          v-on:input="lookupAddress"
          v-click-outside="cleanLookupSuggestions"
        />
        <div class="address_suggestions" v-click-outside="cleanLookupSuggestions">
          <ul>
            <li v-for="(item,index) of address_suggestions_1" :key="'1_' + index">
              <button
                v-on:click="selectAddress1(item.id, item.label)"
                class="suggestion_button"
              >{{item.label}}</button>
            </li>
          </ul>
        </div>
      </div>

      <div class="field_wrap">
        <span class="field_label">Are you a NZ citizen/permanent resident?</span>
        <v-radio-group data-test-id="step-4-is-nz-resident"
          class="radio_place" v-model="Applicant_Is_NZ_Resident" row required>
          <v-radio
            v-for="n in 2"
            v-bind:key="'Applicant_Is_NZ_Resident' + n"
            color="#0200bd"
            :label="getRadioLabel(n)"
            :value="getRadioValue(n)"
            required
          ></v-radio>
        </v-radio-group>
      </div>

      <div class="field_wrap">
        <span
          class="field_label"
        >Is there a partner, director or shareholder you wish to include in your application?</span>
        <v-radio-group data-test-id="step-4-has-second-applicant" class="radio_place" v-model="hasSecondApplicant" row required>
          <v-radio
            v-for="n in 2"
            v-bind:key="'hasSecondApplicant' + n"
            color="#0200bd"
            :label="getRadioLabel(n)"
            :value="getRadioValue(n)"
            required
          ></v-radio>
        </v-radio-group>
      </div>

      <div v-if="hasSecondApplicant">
        <h2 class="details_header">Partner, director or shareholder details</h2>

        <div class="field_wrap textfield_wrap">
          <span class="field_label">First name</span>
          <v-text-field
            outlined
            v-model="Applicant2_First_Name"
            color="#0200b9"
            :rules="name_rules"
            class="text_field"
            maxlength="30"
          />
        </div>

        <div class="field_wrap textfield_wrap">
          <span class="field_label">Last name</span>
          <v-text-field
            outlined
            v-model="Applicant2_Last_Name"
            color="#0200b9"
            :rules="name_rules"
            class="text_field"
            maxlength="30"
          />
        </div>
      <div class="field_wrap textfield_wrap dob_field_wrap">
        <span class="field_label">Date of Birth</span>
        <input v-if="isIE11" v-model="Applicant2_Date_of_Birth" class="text_field" placeholder="dd/mm/yyyy"
          @change="debouncedCheckDob(2)"
          @blur="debouncedCheckDob(2)"
          @keyup="debouncedCheckDob(2)" />
        <input v-else
          class="text_field"
          :class='{invalid: !applicant_2_dob_valid && applicant_2_dob_error}'
          :value="Applicant2_Date_of_Birth"
          v-imask="dateMask"
          @accept="onAccept2"
          @complete="onComplete"
          @blur="debouncedCheckDob(2)"
          @change="debouncedCheckDob(2)"
          @keyup="debouncedCheckDob(2)"
          @focus="focusInput2"
        />
        <span v-if="applicant_2_dob_error" class="error_text">{{applicant_2_dob_error}}</span>
      </div>

        <div class="field_wrap textfield_wrap">
          <span class="field_label">Phone</span>
          <v-text-field
            outlined
            v-model="Applicant2_Phone"
            color="#0200b9"
            :rules="phone_rules"
            class="text_field"
            maxlength="30"
            minlength="9"
          />
        </div>

        <div class="field_wrap textfield_wrap address_lookup_wrap">
          <span class="field_label">Residential address</span>
          <v-text-field
            outlined
            v-model="Applicant2_Address_Text"
            color="#0200b9"
            :rules="name_rules"
            placeholder="Start typing..."
            class="text_field"
            v-on:input="lookupAddress2"
            v-click-outside="cleanLookupSuggestions2"
          />
          <div class="address_suggestions" v-click-outside="cleanLookupSuggestions2">
            <ul>
              <li v-for="(item,index) of address_suggestions_2" :key="'2_' + index">
                <button
                  v-on:click="selectAddress2(item.id, item.label)"
                  class="suggestion_button"
                >{{item.label}}</button>
              </li>
            </ul>
          </div>
        </div>

        <div class="field_wrap">
          <span class="field_label">NZ citizen/permanent resident?</span>
          <v-radio-group class="radio_place" v-model="Applicant2_Is_NZ_Resident" row required>
            <v-radio
              v-for="n in 2"
              v-bind:key="'Applicant2_Is_NZ_Resident' + n"
              color="#0200bd"
              :label="getRadioLabel(n)"
              :value="getRadioValue(n)"
              required
            ></v-radio>
          </v-radio-group>
        </div>

        <div class="field_wrap checkbox_wrap">
          <div class="checkbox_place">
            <label class="checkbox_label">
              <input type="checkbox" v-model="contactApplicant2Authorized" />
              <span class="checkbox_visual"></span>
              <span class="checkbox_label_text">
                I confirm that the partner, director and/or shareholder above has consented to Heartland contacting them about this application
              </span>
            </label>
          </div>
        </div>
      </div>

      <div class="field_wrap">
        <span
          class="field_label"
        >Is there an accountant you wish to include in your application?</span>
        <v-radio-group data-test-id="step-4-has-accountant" class="radio_place" v-model="hasAccountantIncluded" row required>
          <v-radio
            v-for="n in 2"
            v-bind:key="'hasAccountantIncluded' + n"
            color="#0200bd"
            :label="getRadioLabel(n)"
            :value="getRadioValue(n)"
            required
          ></v-radio>
        </v-radio-group>
      </div>

      <div v-if="hasAccountantIncluded">
        <h2 class="details_header">Accountant details</h2>

        <div class="field_wrap textfield_wrap">
          <span class="field_label">Name</span>
          <v-text-field
            outlined
            v-model="Accountant_Name"
            color="#0200b9"
            :rules="name_rules_v2"
            class="text_field"
            maxlength="30"
          />
        </div>

        <div class="field_wrap textfield_wrap">
          <span class="field_label">Accounting firm</span>
          <v-text-field
            outlined
            v-model="Accountant_Firm"
            color="#0200b9"
            class="text_field"
            maxlength="30"
          />
        </div>

        <div class="field_wrap textfield_wrap">
          <span class="field_label">Mobile number</span>
          <v-text-field
            outlined
            v-model="Accountant_Phone"
            color="#0200b9"
            :rules="phone_rules_v2"
            class="text_field"
            maxlength="30"
            minlength="9"
          />
        </div>

        <div class="field_wrap textfield_wrap">
          <span class="field_label">Email address</span>
          <v-text-field
            outlined
            v-model="Accountant_Email"
            type="email"
            color="#0200b9"
            class="text_field"
          />
        </div>

        <div class="field_wrap checkbox_wrap">
          <div class="checkbox_place">
            <label class="checkbox_label">
              <input type="checkbox" v-model="contactAccountantAuthorized" />
              <span class="checkbox_visual"></span>
              <span class="checkbox_label_text">
                I hereby authorise Heartland Bank to contact our accountant to request information on the borrowing entity
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import {IMaskDirective} from 'vue-imask';
import libraryMixin from "./library_mixin";
import debounce from "lodash.debounce"

export default {
  mixins: [libraryMixin],
  directives: {
    imask: IMaskDirective
  },
  props: {
    current: {
      type: Boolean,
      default: false
    },
    header: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      stepIndex: 4,
      valid: false,
      firstTimeDisplayed: true,
      hasSecondApplicant: false,
      Applicant_First_Name: null,
      Applicant_Last_Name: null,
      Applicant_Date_of_Birth: '',
      Applicant_Phone: null,
      Applicant_Address_Text: null,
      Applicant_Address_Details: {},
      Applicant_Is_NZ_Resident: true,
      secondApplicant: false,
      Applicant2_First_Name: null,
      Applicant2_Last_Name: null,
      Applicant2_Date_of_Birth: null,
      Applicant2_Phone: null,
      Applicant2_Address_Text: null,
      Applicant2_Address_Details: {},
      Applicant2_Is_NZ_Resident: true,
      contactApplicant2Authorized: false,
      address_suggestions_1: [],
      address_suggestions_2: [],
      applicant_1_dob_valid: false,
      applicant_2_dob_valid: false,
      applicant_1_dob_error: '',
      applicant_2_dob_error: '',
      hasAccountantIncluded: false,
      contactAccountantAuthorized: false,
      Accountant_Name: null,
      Accountant_Firm: null,
      Accountant_Phone: null,
      Accountant_Email: null,
      isIE11: false
    };
  },
  watch: {
    current: {
      handler(val) {
        if (val) {
          if (this.firstTimeDisplayed) {
            this.Applicant_First_Name = this.$parent.$parent.application.clientInfo.Applicant_First_Name;
            this.Applicant_Last_Name = this.$parent.$parent.application.clientInfo.Applicant_Last_Name;
            this.firstTimeDisplayed = false;
          }
        }
      }
    },
    hasSecondApplicant: {
      handler: function(val) {
        this.valid = this.checkValidity();
        if (val !== null && val !== true) {
          this.Applicant2_First_Name = null;
          this.Applicant2_Last_Name = null;
          this.Applicant2_Date_of_Birth = null;
          this.Applicant2_Phone = null;
          this.Applicant2_Address_Text = null;
          this.Applicant2_Address_Details = {};
          this.contactApplicant2Authorized = false;
          this.updateData();
        }
      }
    },
    hasAccountantIncluded: {
      handler: function(val) {
        this.valid = this.checkValidity();
        if (val !== null && val !== true) {
          this.Accountant_Name = null;
          this.Accountant_Firm = null;
          this.Accountant_Phone = null;
          this.Accountant_Email = null;
          this.contactAccountantAuthorized = false;
          this.updateData();
        }
      }
    }
  },
  computed: {
    personalInfo: function personalInfo() {
      return {
        Applicant_First_Name: this.Applicant_First_Name,
        Applicant_Last_Name: this.Applicant_Last_Name,
        Applicant_Date_of_Birth: this.Applicant_Date_of_Birth,
        Applicant_Address_Text: this.Applicant_Address_Text,
        Applicant_Address_Details: this.Applicant_Address_Details,
        Applicant_Is_NZ_Resident: this.Applicant_Is_NZ_Resident,
        Applicant2_First_Name: this.Applicant2_First_Name,
        Applicant2_Last_Name: this.Applicant2_Last_Name,
        Applicant2_Date_of_Birth: this.Applicant2_Date_of_Birth,
        Applicant2_Phone: this.Applicant2_Phone,
        Applicant2_Address_Text: this.Applicant2_Address_Text,
        Applicant2_Address_Details: this.Applicant2_Address_Details,
        Applicant2_Is_NZ_Resident: this.Applicant2_Is_NZ_Resident,
        contactApplicant2Authorized: this.contactApplicant2Authorized,
        hasSecondApplicant: this.hasSecondApplicant,
        hasAccountantIncluded: this.hasAccountantIncluded,
        contactAccountantAuthorized: this.contactAccountantAuthorized,
        Accountant_Name: this.Accountant_Name,
        Accountant_Firm: this.Accountant_Firm,
        Accountant_Phone: this.Accountant_Phone,
        Accountant_Email: this.Accountant_Email
      };
    },
    dateMask: function dateMask(){
      var momentDateFormat = 'DD/MM/YYYY'
      return {
        mask: Date,
        pattern: momentDateFormat,
        lazy: false,
        min: moment().subtract(100, 'years').toDate(),
        max: moment().subtract(18, 'years').toDate(),
        blocks: {
          DD: {
            mask: IMask.MaskedRange,
            placeholderChar: 'd',
            from: 1,
            to: 31,
            maxLength: 2,
          },
          MM: {
            mask: IMask.MaskedRange,
            placeholderChar: 'm',
            from: 1,
            to: 12,
            maxLength: 2,
          },
          YYYY: {
            mask: IMask.MaskedRange,
            placeholderChar: 'y',
            from: moment().subtract(100, 'years').year(),
            to: moment().year()
          }
        },
        format: function (date) {
          return moment(date).format(momentDateFormat)
        },
        parse: function (str) {
          return moment(str, momentDateFormat)
        }
      }
    }
  },
  updated: function() {
    if (!this.firstTimeDisplayed) {
      this.valid = this.checkValidity();
      this.debouncedDataUpdate();
    }
  },
  methods: {
    updateData: function updateData() {
      this.valid = this.checkValidity();
      this.$emit("updateClientInfo", this.personalInfo);
      this.$emit("stepValid", { step: 4, valid: this.valid });
      this.$emit("sendDataToAPI");
    },
    checkValidity: function checkValidity() {
      this.checkDob(1)
      var this_data = [
        !!this.Applicant_First_Name,
        !!this.Applicant_Last_Name,
        !!this.Applicant_Date_of_Birth,
        !!this.Applicant_Address_Text,
        this.applicant_1_dob_valid
      ];
      if (this.hasSecondApplicant) {
        this.checkDob(2)
        var second_data = [
          !!this.Applicant2_First_Name,
          !!this.Applicant2_Last_Name,
          !!this.Applicant2_Date_of_Birth,
          !!this.Applicant2_Address_Text,
          !!this.Applicant2_Phone,
          this.contactApplicant2Authorized,
          this.applicant_2_dob_valid
        ];
        this_data = this_data.concat(second_data);
      }
      if (this.hasAccountantIncluded) {
        var third_data = [
          !!this.Accountant_Name,
          !!this.Accountant_Phone,
          this.contactAccountantAuthorized
        ];
        this_data = this_data.concat(third_data);
      }
      var isvalid = this_data.every(function(el) {
        return el;
      });

      return isvalid;
    },
    cleanAddress_details: function cleanAddress_details(index) {
      if (index === 1) {
        this.Applicant_Address_Details = {};
      } else {
        this.Applicant2_Address_Details = {};
      }
    },
    fillAddress_details: function fillAddress_details(data, index) {
      if (index === 1) {
        this.Applicant_Address_Details = data;
      } else {
        this.Applicant2_Address_Details = data;
      }
    },
    selectAddress1: function selectAddress1(addressId, addressString) {
      this.Applicant_Address_Text = addressString;
      this.makeDetailedAddressCall(addressId, 1);
      this.address_suggestions_1 = [];
    },
    selectAddress2: function selectAddress2(addressId, addressString) {
      this.Applicant2_Address_Text = addressString;
      this.makeDetailedAddressCall(addressId, 2);
      this.address_suggestions_2 = [];
    },
    isValidDate: function isValidDate(str) {
      if(!str || str.length < 10) return false
      var d = moment(str,'DD/MM/YYYY');
      return d.isAfter(moment().subtract(100,'years'))
    },
    isAdult: function isAdult(str) {
      if(!str || str.length < 10) return false
      var d = moment(str,'DD/MM/YYYY');
      return d.isBefore(moment().subtract(18,'years'))
    },
    debouncedCheckDob: function() {
      return debounce(this.checkDob, 200)
    },
    checkDob: function checkDob(index) {
      if(index===1){
        if (this.Applicant_Date_of_Birth) {
          this.applicant_1_dob_valid = this.isValidDate(this.Applicant_Date_of_Birth) && this.isAdult(this.Applicant_Date_of_Birth)
          if (this.applicant_1_dob_valid) {
            this.applicant_1_dob_error = ''
          } else {
            if (!this.isValidDate(this.Applicant_Date_of_Birth)) {
              this.applicant_1_dob_error = 'Please enter valid date'
            } else if (!this.isAdult(this.Applicant_Date_of_Birth)) {
              this.applicant_1_dob_error = 'Should be 18 years old'
            }
          }
        } else {
          this.applicant_1_dob_valid = false
          this.applicant_1_dob_error = 'Please complete this field'
        }
      }
      else if(index===2){
        if (this.Applicant2_Date_of_Birth) {
          this.applicant_2_dob_valid = this.isValidDate(this.Applicant2_Date_of_Birth) && this.isAdult(this.Applicant2_Date_of_Birth)
          if (this.applicant_2_dob_valid) {
            this.applicant_2_dob_error = ''
          } else {
            if (!this.isValidDate(this.Applicant2_Date_of_Birth)) {
              this.applicant_2_dob_error = 'Please enter valid date'
            } else if (!this.isAdult(this.Applicant2_Date_of_Birth)) {
              this.applicant_2_dob_error = 'Should be 18 years old'
            }
          }
        } else {
          this.applicant_2_dob_valid = false
          this.applicant_2_dob_error = 'Please complete this field'
        }
      }
    },
    onAccept (e) {
      const maskRef = e.detail;
      this.Applicant_Date_of_Birth = maskRef.value;
    },
    onAccept2 (e) {
      const maskRef = e.detail;
      this.Applicant2_Date_of_Birth = maskRef.value;
    },
    onComplete (e) {
      const maskRef = e.detail;
      this.updateData()
    },
    focusInput1: function focusInput1(e){
      if(!this.Applicant_Date_of_Birth || this.Applicant_Date_of_Birth === 'dd/mm/yyyy') {
        var t = e.target;
        var z = this.getFirstPlaceholderSymbolPosition(this.Applicant_Date_of_Birth)
        setTimeout(function(){t.focus(); t.setSelectionRange(z,0)},200)
      }
    },
    focusInput2: function focusInput2(e){
      if(!this.Applicant2_Date_of_Birth || this.Applicant2_Date_of_Birth === 'dd/mm/yyyy') {
        var t = e.target;
        var z = this.getFirstPlaceholderSymbolPosition(this.Applicant2_Date_of_Birth)
        setTimeout(function(){t.focus(); t.setSelectionRange(z,0)},200)
      }
    },
    getFirstPlaceholderSymbolPosition: function getFirstPlaceholderSymbolPosition(data){
      if (!data) return 0;
      var pos_d = data.indexOf('d');
      var pos_m = data.indexOf('m');
      var pos_y = data.indexOf('y');
      var pos = -1;
      if(pos_y > -1) pos = pos_y;
      if(pos_m > -1) pos = pos_m;
      if(pos_d > -1) pos = pos_d;

      if(pos > -1) { return pos; }
      else {
        return data.length - 1
      }
    }
  },
  created: function() {
    this.isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    var app_data = this.$parent.$parent.application.clientInfo;

    this.Applicant_First_Name = app_data.Applicant_First_Name
      ? app_data.Applicant_First_Name
      : null;
    this.Applicant_Last_Name = app_data.Applicant_Last_Name
      ? app_data.Applicant_Last_Name
      : null;
    this.Applicant_Date_of_Birth = app_data.Applicant_Date_of_Birth
      ? app_data.Applicant_Date_of_Birth
      : null;
    this.Applicant_Address_Text = app_data.Applicant_Address_Text
      ? app_data.Applicant_Address_Text
      : null;
    this.Applicant_Address_Details = app_data.Applicant_Address_Details;
    this.Applicant_Is_NZ_Resident =
      typeof app_data.Applicant_Is_NZ_Resident === "undefined"
        ? true
        : app_data.Applicant_Is_NZ_Resident;
    this.Applicant2_First_Name = app_data.Applicant2_First_Name
      ? app_data.Applicant2_First_Name
      : null;
    this.Applicant2_Last_Name = app_data.Applicant2_Last_Name
      ? app_data.Applicant2_Last_Name
      : null;
    this.Applicant2_Date_of_Birth = app_data.Applicant2_Date_of_Birth
      ? app_data.Applicant2_Date_of_Birth
      : null;
    this.Applicant2_Phone = app_data.Applicant2_Phone
      ? app_data.Applicant2_Phone
      : null;
    this.Applicant2_Address_Text = app_data.Applicant2_Address_Text
      ? app_data.Applicant2_Address_Text
      : null;
    this.Applicant2_Address_Details = app_data.Applicant2_Address_Details;
    this.contactApplicant2Authorized =
      typeof app_data.contactApplicant2Authorized === "undefined"
        ? false
        : app_data.contactApplicant2Authorized;
    this.hasSecondApplicant =
      typeof app_data.hasSecondApplicant === "undefined"
        ? false
        : app_data.hasSecondApplicant;
    this.hasAccountantIncluded =
      typeof app_data.hasAccountantIncluded === "undefined"
        ? false
        : app_data.hasAccountantIncluded;    
    this.Accountant_Name = app_data.Accountant_Name
        ? app_data.Accountant_Name
        : null;
    this.Accountant_Firm = app_data.Accountant_Firm
        ? app_data.Accountant_Firm
        : null;
    this.Accountant_Phone = app_data.Accountant_Phone
        ? app_data.Accountant_Phone
        : null;
    this.Accountant_Email = app_data.Accountant_Email
        ? app_data.Accountant_Email
        : null; 
    this.contactAccountantAuthorized =
      typeof app_data.contactAccountantAuthorized === "undefined"
        ? false
        : app_data.contactAccountantAuthorized;   
  }
};
</script>